videojs.addLanguage('en', {
	"Error loading media: File could not be played": "Error loading media: File could not be played",
	"Too many errors. Last error: ": "Too many errors. Last error: ",
	"networkError": "networkError",
	"no level found in manifest": "no level found in manifest. Contact technical support"
});